import React from 'react';
import { Input } from './ui/input';
import { COUNTRIES, DEFAULT_DIAL } from '../lib/countries';

const DIALS_BY_LEN = COUNTRIES.map((c) => c.dial).sort((a, b) => b.length - a.length);

const parse = (full) => {
  const v = String(full || '').replace(/[^\d+]/g, '');
  const match = DIALS_BY_LEN.find((d) => v.startsWith(d));
  if (match) return { dial: match, number: v.slice(match.length) };
  return { dial: DEFAULT_DIAL, number: v.replace(/^\+/, '') };
};

export const PhoneField = ({ value, onChange, testid = 'phone', placeholder = 'Phone number', className = '' }) => {
  const { dial, number } = parse(value);
  const setDial = (d) => onChange(`${d}${number}`);
  const setNumber = (raw) => onChange(`${dial}${raw.replace(/\D/g, '')}`);

  return (
    <div className={`flex gap-2 ${className}`}>
      <select
        value={dial}
        onChange={(e) => setDial(e.target.value)}
        data-testid={`${testid}-country`}
        aria-label="Country code"
        className="h-10 shrink-0 rounded-md border border-input bg-white px-2 text-sm text-gobra-slate focus:outline-none focus:ring-2 focus:ring-gobra-green/30 cursor-pointer"
      >
        {COUNTRIES.map((c) => (
          <option key={c.code} value={c.dial}>{c.code} {c.dial}</option>
        ))}
      </select>
      <Input
        required
        type="tel"
        inputMode="numeric"
        placeholder={placeholder}
        value={number}
        data-testid={`${testid}-number`}
        onChange={(e) => setNumber(e.target.value)}
        onKeyDown={(e) => {
          if (['e', 'E', '+', '-', '.'].includes(e.key)) e.preventDefault();
        }}
        className="flex-1 bg-white"
      />
    </div>
  );
};
